import { QuestionBase } from './question-base';

/*

Sample:

new TextboxQuestion({
  key: 'name',
  label: 'nouns.name',
  // value: 'Peter',
  required: true,
  order: 1
}),

*/
export class HiddenQuestion extends QuestionBase<string> {
  controlType = 'hidden';
  type: string;

  constructor(options: {} = {}) {
    super(options);
  }
}
